import { ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';
import { divWithStyle } from '../style/LayoutComponents';
import { Style, keyframes } from '../style/StyleFunctions';

const fadeInAnimation = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
});

const fadeInStyle: Style = {
  animationName: fadeInAnimation,
  animationDuration: '2s',
  animationTimingFunction: 'ease-in',
};

const centeredStyle: Style = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};


const CenteredContainer = divWithStyle('CenteredContainer', centeredStyle);
const CenteredFadeInContainer = divWithStyle('CenteredFadeInContainer', [centeredStyle, fadeInStyle]);


export function CenteredFadeInSpinner(props: { testId?: string }): JSX.Element {
  return (
    <CenteredFadeInContainer>
      <ActivitySpinnerWidget testId={props.testId ?? ''} />
    </CenteredFadeInContainer>
  );
}

export function CenteredSpinner(props: { testId?: string }): JSX.Element {
  return (
    <CenteredContainer>
      <ActivitySpinnerWidget testId={props.testId ?? ''} />
    </CenteredContainer>
  );
}
